import React from 'react';

export const DragIcon = ({
  width = '10',
  height = '14',
  color = '#D0D5DD',
  'aria-hidden': ariaHidden = true,
  ...rest
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 10 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden={ariaHidden}
    {...rest}
  >
    <path
      d="M4.16732 11.9987C4.16732 12.9154 3.41732 13.6654 2.50065 13.6654C1.58398 13.6654 0.833984 12.9154 0.833984 11.9987C0.833984 11.082 1.58398 10.332 2.50065 10.332C3.41732 10.332 4.16732 11.082 4.16732 11.9987ZM2.50065 5.33203C1.58398 5.33203 0.833984 6.08203 0.833984 6.9987C0.833984 7.91536 1.58398 8.66537 2.50065 8.66537C3.41732 8.66537 4.16732 7.91536 4.16732 6.9987C4.16732 6.08203 3.41732 5.33203 2.50065 5.33203ZM2.50065 0.332031C1.58398 0.332031 0.833984 1.08203 0.833984 1.9987C0.833984 2.91536 1.58398 3.66536 2.50065 3.66536C3.41732 3.66536 4.16732 2.91536 4.16732 1.9987C4.16732 1.08203 3.41732 0.332031 2.50065 0.332031ZM7.50065 3.66536C8.41732 3.66536 9.16732 2.91536 9.16732 1.9987C9.16732 1.08203 8.41732 0.332031 7.50065 0.332031C6.58398 0.332031 5.83398 1.08203 5.83398 1.9987C5.83398 2.91536 6.58398 3.66536 7.50065 3.66536ZM7.50065 5.33203C6.58398 5.33203 5.83398 6.08203 5.83398 6.9987C5.83398 7.91536 6.58398 8.66537 7.50065 8.66537C8.41732 8.66537 9.16732 7.91536 9.16732 6.9987C9.16732 6.08203 8.41732 5.33203 7.50065 5.33203ZM7.50065 10.332C6.58398 10.332 5.83398 11.082 5.83398 11.9987C5.83398 12.9154 6.58398 13.6654 7.50065 13.6654C8.41732 13.6654 9.16732 12.9154 9.16732 11.9987C9.16732 11.082 8.41732 10.332 7.50065 10.332Z"
      fill={color}
    />
  </svg>
);
